module.exports = __webpack_public_path__ + "img/client-lavka.5d564ada.png";